import * as Yup from 'yup'

export const Schema = Yup.object().shape({
    amount: Yup.string().required('مبلغ الزامی می باشد'),
})
